import React from 'react';
import PropTypes from 'prop-types';

import { VpInfoMenu } from '../../components';
import { usePluginsContext } from '../../../hooks';

const menuItems = [
  {
    id: 'delete',
    label: 'Delete',
    icon: 'Trash2',
    variant: 'error'
  }
];

export const VpPluginInfoMenu = ({ pluginId }) => {
  const { setSelectedPluginId } = usePluginsContext();

  const onSelect = (item) => {
    switch (item?.id) {
      case 'delete': {
        setSelectedPluginId(pluginId);
        return;
      }
    }
  };

  return <VpInfoMenu id={pluginId} menuItems={menuItems} onSelect={onSelect} />;
};

VpPluginInfoMenu.propTypes = {
  pluginId: PropTypes.string,
  onDelete: PropTypes.func
};

export default VpPluginInfoMenu;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/VpPluginInfoMenu.jsx